import React from 'react';
import PersonSelector from '../../common/components/PersonSelector';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormPanel from '../../common/form/FormPanel';
import FormWidget from '../../common/form/FormWidget';
import I18n from '../../common/i18n/I18n';
import { LineItemTypeEnum } from '../../shortlists/form/ShortlistLineItemItems';

export default () => {
    const filter = {
        expressions: [
            {
                field: 'type',
                value: { values: ['Facility'] }
            }
        ]
    };

    const mockCreateReferenceOption = async (newValue) => {
        const label = newValue?.label || newValue?.ref?.label || '';
        const idSuffix = (label || 'new-person').toLowerCase().replace(/\s+/g, '-');
        return {
            id: `mock-${idSuffix}`,
            label,
            ref: {
                id: `mock-${idSuffix}`,
                label,
                uriPrefix: ''
            }
        };
    };

    return (
        <FormPanel>
            <FormContainer>
                <FormItem half>
                    <PersonSelector
                        name="person"
                        label="Contact"
                        multiple={false}
                        autoFocus={false}
                        placeholder={'Contact name and details'}
                        noOptionsText={'Search for contacts by name'}
                        setIsScrollable={(isScrollable) => {
                            console.log('setIsScrollable:', isScrollable);
                        }}
                    />
                </FormItem>
                <FormItem half>
                    <PersonSelector
                        name="personMulti"
                        label="Contact multi"
                        multiple={true}
                        autoFocus={false}
                        placeholder={'Contact name and details'}
                        noOptionsText={'Search for contacts by name'}
                        setIsScrollable={(isScrollable) => {
                            console.log('setIsScrollable:', isScrollable);
                        }}
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem half>
                    <FormWidget
                        name="personNew"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Person"
                        label="Reference Person"
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        multiple
                        name="personNewMulti"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Person"
                        label="Reference Person multi"
                    />
                </FormItem>
            </FormContainer>

            <FormContainer>
                <FormItem half>
                    <FormWidget
                        name="product"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Product"
                        label="Reference"
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        multiple
                        name="productMulti"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Product"
                        label="Reference multi"
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem half>
                    <FormWidget
                        multiple
                        name="productMulti"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Product"
                        label="Reference tooltip text"
                        tooltip={'Hi I am a tooltip'}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        multiple
                        name="productMulti"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Product"
                        label="Reference tooltip function"
                        tooltip={(option) => {
                            return `Hi I am a tooltip for ${option.label}`;
                        }}
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem third>
                    <FormWidget
                        name="personMultiMatch"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Person"
                        label="Reference Multiple Match Found For Tom"
                        showMatchAdornment
                        addOption
                        queryTerm={'Tom Cruise'}
                    />
                </FormItem>
                <FormItem third>
                    <FormWidget
                        name="personExactMatch"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Person"
                        label="Reference Exact Match Found"
                        showMatchAdornment
                        addOption
                        queryTerm={'Simran Kaur'}
                    />
                </FormItem>
                <FormItem third>
                    <FormWidget
                        name="personNoMatch"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Person"
                        label="Reference No Match Found"
                        showMatchAdornment
                        addOption
                        queryTerm={'kapil charu'}
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem>
                    <FormWidget
                        type="chips"
                        name="productChips"
                        filter={filter}
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Product"
                        label="Reference chips"
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem>
                    <FormWidget
                        type="radio"
                        name="productRadio"
                        filter={filter}
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity="Product"
                        label="Reference radio"
                    />
                </FormItem>
            </FormContainer>

            <FormContainer>
                <FormItem half>
                    <FormWidget
                        name="location"
                        component={FORM_WIDGET_COMPONENTS.location}
                        label="Location"
                        required={true}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        multiple
                        name="locationMulti"
                        component={FORM_WIDGET_COMPONENTS.location}
                        label="Location"
                        required={true}
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem half>
                    <FormWidget
                        disabled
                        name="location"
                        component={FORM_WIDGET_COMPONENTS.location}
                        label="Disabled location"
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        disabled
                        multiple
                        name="locationMulti"
                        component={FORM_WIDGET_COMPONENTS.location}
                        label="Disabled location multi"
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem half>
                    <FormWidget
                        allowFreeForm
                        skipReferenceCreationOnNoMatch
                        addOption
                        onCreateHandle={() => {}}
                        entity={LineItemTypeEnum.organization}
                        preload={false}
                        name="referenceAutocompleteOrgs"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        label={<I18n token="form.add.or.select.organizations" />}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        allowFreeForm
                        skipReferenceCreationOnNoMatch
                        addOption
                        onCreateHandle={() => {}}
                        entity={LineItemTypeEnum.person}
                        preload={false}
                        name="referenceAutocompletePeople"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        label={<I18n token="form.add.or.select.people" />}
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem>
                    <FormWidget
                        name="referenceAutoSelectFirstOption"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        label={<I18n token="form.auto.select.first.option" />}
                        entity={LineItemTypeEnum.person}
                        addOption
                        onCreateHandle={() => {}}
                        preload={false}
                        autoSelectFirstOption
                        notOnlyRef
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem half>
                    <FormWidget
                        name="referenceAutocompletePersonAISingle"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        label="Reference Person AI single"
                        entity={LineItemTypeEnum.person}
                        addOption
                        onCreateHandle={mockCreateReferenceOption}
                        preload={false}
                        queryTerm={'Carolyn Johnson'}
                        isAIExtractedData
                        requiresUserCorrection
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        multiple
                        name="referenceAutocompletePersonAIMultiple"
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        label="Reference Person AI multiple"
                        entity={LineItemTypeEnum.person}
                        addOption
                        onCreateHandle={mockCreateReferenceOption}
                        preload={false}
                        isAIExtractedData
                        requiresUserCorrection
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
